export const EProviderAccountType = {
  COMPANY_BALANCE: "company_balance",
  CUSTODY: "custody",
  FASTER_PAY_RESERVE: "faster_pay_reserve",
  TAX: "tax",
  RESERVE: "reserve",
  DEDUCTIONS: "deductions",
  PAYCARD: "paycard",
} as const;

export type TProviderAccountType =
  (typeof EProviderAccountType)[keyof typeof EProviderAccountType];
